import { gql } from 'graphql-request';
import { Company } from './companyFragmentDeprecated';

export type Valuation = {
  contentHtml: string;
  discountRate: number | null;
  fairValue: number;
  futurePePercentageChange: number | null;
  futureSharesOutstanding: number | null;
  growthRate?: number | null;
  profitMarginPercentageChange: number | null;
  revenuePercentageChange: number | null;
  sharePriceAtPublish?: number | null;
  timeframe: number | null;
  title?: string | null;
  type:
    | 'base'
    | 'bear'
    | 'bull'
    | 'dcf'
    | 'analysts'
    | 'user_defined'
    | 'legacy';
  valuationByLine?: string | null;
  valuatorToolLink?: string | null;
};

export type Author = {
  displayName: string | null;
  id: string;
  imageUrl: string | null;
  name: string;
  role: string;
  slug: string;
  url: string | null;
};

export type ContentBlock = {
  contentHtml: string;
  id?: string;
  title: string;
};

export type Announcement = {
  contentHtml: string;
  createdAt: string;
  id: string;
};

export type VoteCount = {
  downvotes: number;
  upvotes: number;
};

export type NarrativeFragmentType = {
  companyId: string;
  contentBlocks: ContentBlock[];
  id: string;
  slug: string;
  title: string;
  valuations: Valuation[];
  voteCount: VoteCount;
  announcements: Announcement[];
  author: Author;
  company: Company;
  companyCanonicalUrl: string;
  coverImageUrl: string;
  updatedAt: string;
  publishedAt: string;
  status: 'draft' | 'published' | 'archived';
  currencyIso: string;
  userHoldsPosition: boolean;
  visibility: 'public' | 'private';
  type: 'AI' | 'FAIR_VALUE' | 'LEGACY' | 'USER' | 'WARREN' | null;
};

export const NARRATIVE_FRAGMENT = gql`
  fragment NarrativeFields on Narrative {
    companyId
    contentBlocks {
      contentHtml
      id
      title
    }
    id
    slug
    title
    valuations {
      contentHtml
      discountRate
      fairValue
      futurePePercentageChange
      futureSharesOutstanding
      growthRate
      profitMarginPercentageChange
      revenuePercentageChange
      timeframe
      title
      type
      valuationByLine
      valuatorToolLink
    }
    voteCount {
      downvotes
      upvotes
    }
    announcements {
      contentHtml
      createdAt
      id
    }
    currencyIso
    userHoldsPosition
    status
    coverImageUrl
    publishedAt
    updatedAt
    visibility
    type
    author {
      displayName
      id
      imageUrl
      name
      role
      slug
      url
    }
  }
`;
